// Stable per-install device id for the password-free device sign-in route.
export const DEVICE_ID_KEY = 'aeonia:device-id';

export function loadOrCreateDeviceId(storage: Storage = globalThis.localStorage): string {
  const existing = storage.getItem(DEVICE_ID_KEY);
  if (existing) return existing;
  const id = generateDeviceId();
  storage.setItem(DEVICE_ID_KEY, id);
  return id;
}

/**
 * Generates a fresh device id with the same generator `loadOrCreateDeviceId`
 * uses, without reading or writing any storage. Used for the "every page
 * load is a new run" default, where each run needs its own id but nothing
 * should be persisted.
 */
export function generateDeviceId(): string {
  return globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
